import { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";

const OrderingFilter = ({ onChange, clearFilter, value }) => {
    const [selectedOrderingValue, setSelectedOrderingValue] = useState('');

    const orderingOptions = [
        { value: 'asc', label: 'Crescente' },
        { value: 'desc', label: 'Decrescente' },
    ];

    useEffect(() => {
        setSelectedOrderingValue(value || '');
    }, [value]);

    useEffect(() => {
        if (clearFilter) {
            setSelectedOrderingValue('');
            onChange(null);
        }
    }, [clearFilter, onChange]);

    const handleOrderingChange = (newValue) => {
        setSelectedOrderingValue(newValue);
        onChange?.(newValue || null);
    };

    return (
        <FormControl sx={{ minWidth: '270px' }}>
            <InputLabel
                id="order-by-select-label"
                shrink
            >
                Ordem
            </InputLabel>

            <Select
                labelId="order-by-select-label"
                value={selectedOrderingValue}
                label="Ordem"
                displayEmpty
                onChange={(event) => handleOrderingChange(event.target.value)}
                renderValue={(selected) =>
                    selected
                        ? orderingOptions.find(opt => opt.value === selected)?.label
                        : <Typography color="text.disabled">-</Typography>
                }
            >
                {orderingOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default OrderingFilter;